import { BadgePercent } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useBuyerPricing } from './buyerPricing.js';

/**
 * "Your group's prices" pill — shown only to a signed-in customer whose party is
 * on a price list, so they can see WHY the numbers differ from the public store
 * (and, when their group is priced in another currency, in what).
 */
export function GroupPricingBadge({ className = '' }: { className?: string }): JSX.Element | null {
  const { t } = useTranslation('cms');
  const buyer = useBuyerPricing();
  if (!buyer.priceListName) return null;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-brand/30 bg-brand/10 px-3 py-1 text-xs font-medium text-brand ${className}`}
      title={t('store.pricing.groupHint', { defaultValue: 'Prices shown for your customer group.' })}
    >
      <BadgePercent className="h-3.5 w-3.5" aria-hidden />
      {t('store.pricing.groupNote', { group: buyer.priceListName, currency: buyer.currencyCode, defaultValue: '{{group}} prices · {{currency}}' })}
    </span>
  );
}
